import { ApiConfig } from '../../server/shared/client/ApiConfig';

ApiConfig.baseEndpoint = '/api';

export * from '../../server/shared/client';
